var _path, _path2, _path3, _g, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66433 12.2591H1.62345C1.29224 12.2591 1.02344 12.0055 1.02344 11.693C1.02344 11.3805 1.29224 11.127 1.62345 11.127H6.66433C6.99554 11.127 7.26435 11.3805 7.26435 11.693C7.26435 12.0055 6.99554 12.2591 6.66433 12.2591Z",
    fill: "#727190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9526 4.94265H8.91251C8.5813 4.94265 8.3125 4.68906 8.3125 4.3766C8.3125 4.06414 8.5813 3.81055 8.91251 3.81055H13.9526C14.2838 3.81055 14.5526 4.06414 14.5526 4.3766C14.5526 4.68906 14.2838 4.94265 13.9526 4.94265Z",
    fill: "#727190"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_3031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 5,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2H5.98073V6.67302H1V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_3031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4905 3.13221C2.77928 3.13221 2.20007 3.6726 2.20007 4.33753C2.20007 5.00169 2.77928 5.54133 3.4905 5.54133C4.20251 5.54133 4.78092 5.00169 4.78092 4.33753C4.78092 3.6726 4.20251 3.13221 3.4905 3.13221ZM3.49044 6.67332C2.11762 6.67332 1 5.62575 1 4.33742C1 3.04908 2.11762 2 3.49044 2C4.86407 2 5.98089 3.04908 5.98089 4.33742C5.98089 5.62575 4.86407 6.67332 3.49044 6.67332Z",
    fill: "#727190"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5107 10.4583C11.7987 10.4583 11.2195 10.9986 11.2195 11.6628C11.2195 12.3277 11.7987 12.8674 12.5107 12.8674C13.2219 12.8674 13.8003 12.3277 13.8003 11.6628C13.8003 10.9986 13.2219 10.4583 12.5107 10.4583ZM12.5108 13.9995C11.1372 13.9995 10.0195 12.9512 10.0195 11.6628C10.0195 10.3745 11.1372 9.32617 12.5108 9.32617C13.8836 9.32617 15.0004 10.3745 15.0004 11.6628C15.0004 12.9512 13.8836 13.9995 12.5108 13.9995Z",
    fill: "#727190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d9093af55467817962a00d98992e6d99.svg";
export { ForwardRef as ReactComponent };